import { Box, Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

// Created this util function because when we implement scientific names
// we will also need the italic style for the species data grid

export const renderItalicCell = (params: GridRenderCellParams) => (
    <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
        <Typography
            variant="body2"
            sx={{
                fontStyle: "italic",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
            }}
        >
            {params.value}
        </Typography>
    </Box>
);
